import { createEpicMiddleware } from 'redux-observable';
import rootReducer from './root-reducer';
import rootEpic from './root-epic';
import { createBrowserHistory } from 'history';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import { configureStore } from '@reduxjs/toolkit';
import {TypedUseSelectorHook, useSelector} from "react-redux";

export const history = createBrowserHistory();
const routerMiddleware = createRouterMiddleware(history);
const epicMiddleware = createEpicMiddleware();

const store = configureStore({reducer: rootReducer(history)});
export const UseAppDispatch = () => store.dispatch;

export type RootState = ReturnType<typeof store.getState>;
export const UseAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;

epicMiddleware.run(rootEpic);
